import { API } from "../api";

export const memberOwnExitApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getMemberExitEligibility: builder.query({
      query: () => "/members/exit/eligibility?guard=member",
      transformResponse: (responseData) => responseData?.data,
      providesTags: [{ type: "MemberExit", id: "ELIGIBILITY" }],
    }),
    getMyMemberExitRequest: builder.query({
      query: () => "/members/exit/request?guard=member",
      transformResponse: (responseData) => responseData?.data,
      providesTags: [{ type: "MemberExit", id: "REQUEST" }],
    }),
    createMemberExitRequest: builder.mutation({
      query: (body) => ({
        url: "/members/exit/request?guard=member",
        method: "POST",
        body: body || {},
      }),
      transformResponse: (responseData) => responseData?.data,
      invalidatesTags: [
        { type: "MemberExit", id: "ELIGIBILITY" },
        { type: "MemberExit", id: "REQUEST" },
      ],
    }),
    cancelMemberExitRequest: builder.mutation({
      query: (requestId) => ({
        url: `/members/exit/request/${requestId}/cancel?guard=member`,
        method: "PUT",
      }),
      transformResponse: (responseData) => responseData?.data,
      invalidatesTags: [
        { type: "MemberExit", id: "ELIGIBILITY" },
        { type: "MemberExit", id: "REQUEST" },
      ],
    }),
  }),
});

export const {
  useGetMemberExitEligibilityQuery,
  useGetMyMemberExitRequestQuery,
  useCreateMemberExitRequestMutation,
  useCancelMemberExitRequestMutation,
} = memberOwnExitApi;
